export const FontWeight = {
  s2: 300,
  s1: 400,
  base: 500,
  l1: 600,
  l2: 700,
};
